import Vue from 'vue';

export default {

    getAll() {
        return Vue.prototype.$http.get('/recursos');
    }
}
